export default __webpack_public_path__ + "static/image 1-1d2f0253f1ac59ac55d9960e58639a1a.png";